import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import {
  BidHistoryResponse,
  CampaignBidData,
} from "../../features/AppCountryReports/interface";
import { useAuth } from "../helper";

interface CampaignBidHistoryParams {
  campaignId: number;
}

interface CampaignBidDataParams {
  appSlug: string;
  countryCode: string;
}

export const useCampaignBidHistory = (params: CampaignBidHistoryParams) => {
  const { selectedIntegration } = useAuth();
  const { campaignId } = params;

  return useQuery({
    queryKey: ["campaignBidHistory", selectedIntegration?.value, campaignId],
    queryFn: async () => {
      const response = await httpService.get<BidHistoryResponse>(
        API_CONFIG.path.getCampaignHistory,
        {
          campaign_id: campaignId,
          tracking_id: selectedIntegration?.value as string,
        }
      );
      return response;
    },
    // Only fetch if we have a campaign ID
    enabled: !!selectedIntegration?.value && !!campaignId,
  });
};

export const useCampaignBidData = (params: CampaignBidDataParams) => {
  const { selectedIntegration } = useAuth();
  const { appSlug, countryCode } = params;

  return useQuery({
    queryKey: ["campaignBidData", appSlug, countryCode, selectedIntegration?.value],
    queryFn: async () => {
      const response = await httpService.get<CampaignBidData>(
        API_CONFIG.path.getAppBidManagement,
        {
          slug: appSlug,
          country_code: countryCode,
          tracking_id: selectedIntegration?.value as string,
        }
      );
      return response;
    },
    // Only fetch if we have a campaign ID
    enabled: !!selectedIntegration?.value && !!appSlug && !!countryCode,
  });
};